import { CardColumns as _CardColumns, CardColumnsProps as _CardColumnsProps } from "reactstrap";

    export const CardColumns = _CardColumns;
    export type CardColumnsProps = _CardColumnsProps;
    